var map = {
	"./PombalCupText.svg": 5136,
	"./equipa_.png": 1566,
	"./equipa_1.png": 2597,
	"./equipa_10.png": 5537,
	"./equipa_101.png": 3484,
	"./equipa_102.png": 2487,
	"./equipa_103.png": 9998,
	"./equipa_104.png": 6737,
	"./equipa_105.png": 2872,
	"./equipa_106.png": 9731,
	"./equipa_107.png": 1978,
	"./equipa_108.png": 9757,
	"./equipa_109.png": 5860,
	"./equipa_11.png": 920,
	"./equipa_110.png": 2826,
	"./equipa_111.png": 8387,
	"./equipa_112.png": 2776,
	"./equipa_113.png": 3905,
	"./equipa_114.png": 5422,
	"./equipa_115.png": 4919,
	"./equipa_116.png": 988,
	"./equipa_117.png": 3253,
	"./equipa_118.png": 1874,
	"./equipa_119.png": 2379,
	"./equipa_12.png": 1763,
	"./equipa_120.png": 2427,
	"./equipa_121.png": 882,
	"./equipa_123.png": 1216,
	"./equipa_124.png": 9247,
	"./equipa_125.png": 5446,
	"./equipa_126.png": 861,
	"./equipa_127.png": 7620,
	"./equipa_128.png": 7811,
	"./equipa_129.png": 7978,
	"./equipa_13.png": 6554,
	"./equipa_130.png": 6640,
	"./equipa_132.png": 8386,
	"./equipa_133.png": 2043,
	"./equipa_14.png": 1221,
	"./equipa_15.png": 1804,
	"./equipa_16.png": 2439,
	"./equipa_17.png": 9422,
	"./equipa_18.png": 8809,
	"./equipa_19.png": 1904,
	"./equipa_2.png": 798,
	"./equipa_20.png": 7356,
	"./equipa_21.png": 6453,
	"./equipa_22.png": 9102,
	"./equipa_23.png": 7415,
	"./equipa_24.png": 5896,
	"./equipa_25.png": 113,
	"./equipa_26.png": 9946,
	"./equipa_27.png": 1171,
	"./equipa_28.png": 3508,
	"./equipa_29.png": 9805,
	"./equipa_3.png": 3815,
	"./equipa_30.png": 3623,
	"./equipa_31.png": 4126,
	"./equipa_32.png": 1957,
	"./equipa_33.png": 9692,
	"./equipa_34.png": 7091,
	"./equipa_35.png": 1530,
	"./equipa_36.png": 2609,
	"./equipa_37.png": 1480,
	"./equipa_38.png": 6287,
	"./equipa_39.png": 1094,
	"./equipa_4.png": 8648,
	"./equipa_40.png": 1866,
	"./equipa_41.png": 7427,
	"./equipa_42.png": 1816,
	"./equipa_43.png": 2945,
	"./equipa_44.png": 4462,
	"./equipa_45.png": 3959,
	"./equipa_46.png": 28,
	"./equipa_47.png": 2293,
	"./equipa_48.png": 914,
	"./equipa_49.png": 1419,
	"./equipa_5.png": 6913,
	"./equipa_50.png": 4789,
	"./equipa_51.png": 2524,
	"./equipa_52.png": 1527,
	"./equipa_53.png": 9038,
	"./equipa_54.png": 5777,
	"./equipa_55.png": 1912,
	"./equipa_56.png": 8771,
	"./equipa_58.png": 8797,
	"./equipa_59.png": 4900,
	"./equipa_6.png": 7930,
	"./equipa_60.png": 5680,
	"./equipa_61.png": 1433,
	"./equipa_62.png": 7426,
	"./equipa_63.png": 1083,
	"./equipa_64.png": 9092,
	"./equipa_65.png": 221,
	"./equipa_67.png": 1551,
	"./equipa_69.png": 4990,
	"./equipa_7.png": 3139,
	"./equipa_70.png": 1467,
	"./equipa_71.png": 9922,
	"./equipa_72.png": 4457,
	"./equipa_76.png": 9901,
	"./equipa_77.png": 6660,
	"./equipa_78.png": 6851,
	"./equipa_79.png": 7018,
	"./equipa_8.png": 868,
	"./equipa_80.png": 9086,
	"./equipa_81.png": 2103,
	"./equipa_82.png": 1468,
	"./equipa_83.png": 885,
	"./equipa_84.png": 6218,
	"./equipa_85.png": 1427,
	"./equipa_86.png": 584,
	"./equipa_87.png": 5201,
	"./equipa_88.png": 5398,
	"./equipa_89.png": 8063,
	"./equipa_9.png": 8349,
	"./equipa_90.png": 7673,
	"./equipa_91.png": 6496,
	"./equipa_92.png": 4827,
	"./equipa_93.png": 6962,
	"./equipa_96.png": 7823,
	"./equipa_97.png": 7846,
	"./equipa_98.png": 9777,
	"./equipa_99.png": 5560,
	"./equipa__47.png": 1448,
	"./letras_banner.png": 7122,
	"./letras_banner_.png": 6175,
	"./letras_banner__.png": 5160,
	"./pdf/iv_pombalcup_condicoes.pdf": 422,
	"./pdf/iv_pombalcup_protecaodados.pdf": 5069,
	"./pdf/iv_pombalcup_regulamento.pdf": 8008,
	"./pdf/v_pombalcup_condicoes.pdf": 1007,
	"./pdf/v_pombalcup_protecaodados.pdf": 6376,
	"./pdf/v_pombalcup_regulamento.pdf": 5717,
	"./pdf/v_pombalcup_termoresponsabilidade.pdf": 238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;